import React, { Component, useState, useEffect } from "react";
import { getExternalFiles } from "../../../../service/index"
// require('./index.less');

class ExternalFiles extends Component {
	constructor(props) {
		super(props)
		this.state = {
			__html__: ''
		}
	}

	componentDidMount() {
		this.getExternalHTML()
		// this.asyncImportJs()
		setTimeout(() => {
			this.asyncImportLangJs()
		},1000)
	}

	asyncImportLangJs(){
		(function () {
			try {
				let s = document.createElement("script");
				let x = document.getElementsByTagName("script")[0];
				s.type = "text/javascript";
				s.src = "https://js.dhresource.com/seller/common/headerLang2023.js";
				x.parentNode.insertBefore(s, x);
			} catch (e) { }
			})();
	}

	asyncImportJs() {
		(function () {
			try {
				let s = document.createElement("script");
				let x = document.getElementsByTagName("script")[0];
				s.type = "text/javascript";
				s.src = "https://js.dhresource.com/seller/common/jquery.js";
				x.parentNode.insertBefore(s, x);
			} catch (e) { }
		})();
	}

	
	getExternalHTML() {
		let { uri, params, staticRes } = this.props.data;
		if (staticRes) {
			this.setState({
				__html__: staticRes
			})
		} else {
			getExternalFiles(uri, params).then((result) => {
				this.setState({
					__html__: result
				})
			}).catch((err) => {
				this.setState({
					__html__: ""
				})
			});
		}
	}

	render() {
		let { __html__ } = this.state;
		let { uri, params } = this.props.data;
		return __html__ ? <div className="externalfiles" dangerouslySetInnerHTML={{ __html: __html__ }}></div> : <div style={{ 'display': 'none' }}>{uri} Not Found</div>
	}
}

export default ExternalFiles
